// © Microsoft Corporation. All rights reserved.

/**
 * Enum for different app types
 * @enum
 */
export enum AppType {
    BingHomepage = "bingHomepage",
    Community = "community",
    ContentTools = "contentTools",
    Edge = "edge",
    EdgeChromium = "edgeChromium",
    Finance = "finance",
    FirstParty = "firstParty",
    HomePage = "homePage",
    Hub = "hub",
    MediaSvc = "mediasvc",
    Hybrid = "hybrid",
    MicrosoftNews = "microsoftNews",
    MMX = "mmx",
    NewsAndInterests = "newsAndInterests",
    Office = "office",
    qna = "qna",
    Recipes = "recipes",
    SharedWidgets = "sharedWidgets",
    SuperApp = "superApp",
    Shopping = "shopping",
    Traffic = "traffic",
    Travel = "travel",
    UGC = "ugc",
    Views = "views",
    Weather = "weather",
    Windows = "windows",
    WindowsNewsPlus = "windowsNewsPlus",
    WindowsShell = "windowsShell",
    WindowsNewsBar = "windowsNewsbar"
}

/**
 * Card style mode
 */
export enum CardStyleMode {
    Default = "Default",
    WinDashboard = "WinDashboard",
    Edge = "Edge"
}
